function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Translate } from "../../I18N";
import Modal from "../../Layout/Modal";

import { Icon } from "../../UI";
import { saveThesaurus } from "../actions/thesauriActions";

const mapStateToProps = (state) => ({
  thesauri: state.thesauris
});

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    thesaurusSave: saveThesaurus
  },
  dispatch
);

const connector = connect(mapStateToProps, mapDispatchToProps);



const AddThesaurusButton = ({ thesaurusSave, thesauri }) => {var _errors$thesaurus, _errors$thesaurus2;
  const [open, setOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit'
  });

  const onSave = (data) => {
    const thesaurus = {
      name: data.thesaurus,
      values: []
    };
    thesaurusSave(thesaurus);
    setOpen(false);
  };

  const isNotDuplicated = (value) =>
  !(thesauri !== null && thesauri !== void 0 && thesauri.find(
    (thesaurus) => (thesaurus === null || thesaurus === void 0 ? void 0 : thesaurus.get('type')) !== 'template' && (thesaurus === null || thesaurus === void 0 ? void 0 : thesaurus.get('name')) === value
  ));

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-default", onClick: () => setOpen(true) }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "book" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Add thesaurus" }, void 0, "Add thesaurus")
    )
    ), /*#__PURE__*/

    _jsx(Modal, { isOpen: open, type: "content", className: "new-thesaurus-modal" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h3", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Add thesaurus" }, void 0, "Add thesaurus")
    ), /*#__PURE__*/
    _jsx("p", { className: "description" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Add thesaurus modal description" }, void 0, "After creation you can go into Settings -> Thesauri to add items"

    )
    )
    ), /*#__PURE__*/

    _jsx("form", {}, void 0, /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "thesaurusInput" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Thesaurus" }, void 0, "Thesaurus")
    ), /*#__PURE__*/
    React.createElement("input", _extends({
      type: "text",
      id: "thesaurusInput" },
    register('thesaurus', {
      required: true,
      validate: {
        duplicated: (value) => isNotDuplicated(value)
      }
    }), {
      autoComplete: "off" })
    ),

    ((_errors$thesaurus = errors.thesaurus) === null || _errors$thesaurus === void 0 ? void 0 : _errors$thesaurus.type) === 'required' && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "This field is required" }, void 0, "This field is required"

    )
    ),


    ((_errors$thesaurus2 = errors.thesaurus) === null || _errors$thesaurus2 === void 0 ? void 0 : _errors$thesaurus2.type) === 'duplicated' && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Duplicated name" }, void 0, "Duplicated name")
    )

    ), /*#__PURE__*/

    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn", onClick: () => setOpen(false) }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Cancel" }, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-success", onClick: handleSubmit(onSave) }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Save" }, void 0, "Save")
    )
    )
    )
    )
    ));

};

const container = connector(AddThesaurusButton);
export { container as AddThesaurusButton };